import { FC, ReactNode } from 'react';
import classNames from 'classnames';

type AccordionButtonProps = {
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  children: ReactNode;
  variant?: 'next' | 'submit';
  className?: string;
  isSubmitting?: boolean;
  submittingText?: string;
};

export const AccordionButton: FC<AccordionButtonProps> = ({
  onClick,
  type = 'button',
  disabled = false,
  children,
  variant = 'next',
  className,
  isSubmitting = false,
  submittingText = 'Publishing...',
}) => {
  const baseClasses = 'submit-button btn btn-secondary';
  const variantClasses = variant === 'submit' ? 'btn-inkBlue row' : 'btn-inkBlue-inverted';

  return (
    <button
      type={type}
      className={classNames(baseClasses, variantClasses, className)}
      onClick={onClick}
      disabled={disabled}
    >
      {isSubmitting ? submittingText : children}
    </button>
  );
};
